module.exports = __webpack_public_path__ + "img/logo-axroad-black.5dd8d6c3.svg";